import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Collapse from '@material-ui/core/Collapse'
import Link from '@material-ui/core/Link'
import Typography from '@material-ui/core/Typography'
import { email, phone } from 'constants/contact'
import React, { FC, useCallback, useState } from 'react'
import { scopedTranslation } from 'src/helpers'

import { useStyles } from './MobileContact.styles'

const { t } = scopedTranslation('application.footer')

export const MobileContact: FC = () => {
  const [ isOpen, setIsOpen ] = useState(false)

  const classes = useStyles({ isOpen })

  const toggleState = useCallback(() => {
    setIsOpen(prevState => !prevState)
  }, [ setIsOpen ])

  return (
    <Box className={ classes.section } display='flex' justifyContent='center' flexDirection='column' flexWrap='nowrap'>
      <Button className={ classes.button } onClick={ toggleState } disableRipple={ true }>
        <Typography className={ classes.label } variant='body2'>{ t('contact') }</Typography>
      </Button>
      <Box className={ classes.content } display='flex' flexDirection='column' flexWrap='nowrap'>
        <Collapse in={ isOpen }>
          <Box display='flex' flexWrap='wrap'>
            <Typography className={ classes.text } component='span' variant='body2'>{ t('customer_service') }</Typography>
            <Link className={ classes.link } href={ `tel:${phone}` }>
              <Typography className={ classes.text } component='span' variant='body2'>{`${phone} (${t('calling_times')})`}</Typography>
            </Link>
            <Link className={ classes.link } href={ `mailto:${email}` }>
              <Typography className={ classes.text } component='span' variant='body2'>{ email }</Typography>
            </Link>
          </Box>
        </Collapse>
      </Box>
    </Box>
  )
}
